import React from 'react';
import { Link } from 'react-router-dom';
import BlogArticleLayout, { blogStyles as s } from './BlogArticleLayout';

function BlogArticleGestionFournisseursIA() {
  return (
    <BlogArticleLayout
      tag="IA & Cybersécurité"
      title="Gestion des fournisseurs IA : les points de contrôle essentiels"
      date="15 décembre 2026"
      ctaTitle="Passez en revue vos fournisseurs d'IA"
      ctaText="Le diagnostic vous aide à formaliser les points de contrôle à vérifier auprès de chaque fournisseur d'IA que vous utilisez."
    >
      <p style={s.intro}>
        Quand une entreprise utilise l'IA, elle dépend presque toujours d'un ou plusieurs fournisseurs
        externes — éditeurs de modèles, plateformes intégrant de l'IA, prestataires spécialisés. Cette
        dépendance déplace une partie du risque cybersécurité vers votre chaîne d'approvisionnement, sans le
        supprimer.
      </p>

      <h2 style={s.h2}>Où sont hébergées vos données ?</h2>
      <p>
        La localisation géographique de l'hébergement détermine le cadre juridique applicable à vos données.
        Un fournisseur hébergé en France ou dans l'Union européenne simplifie généralement vos obligations
        RGPD par rapport à un transfert hors UE, qui nécessite des garanties contractuelles supplémentaires.
      </p>

      <h2 style={s.h2}>Vos données servent-elles à entraîner le modèle du fournisseur ?</h2>
      <p>
        C'est l'une des questions les plus structurantes : certains fournisseurs excluent contractuellement
        l'utilisation des données clients pour l'entraînement de leurs modèles publics, d'autres non par
        défaut. Cette clause doit être vérifiée explicitement, pas supposée.
      </p>

      <h2 style={s.h2}>Quelles garanties de sécurité sont contractualisées ?</h2>
      <p>
        Chiffrement des données en transit et au repos, durée de conservation des journaux, procédure en cas
        de violation de données chez le fournisseur lui-même : ces éléments doivent apparaître dans le contrat
        ou les conditions d'utilisation B2B, pas seulement dans une communication marketing.
      </p>

      <h2 style={s.h2}>Que se passe-t-il en cas de défaillance du fournisseur ?</h2>
      <p>
        Une panne, une faillite ou un changement de conditions unilatéral chez votre fournisseur d'IA peut
        interrompre un processus métier qui en dépend. Anticiper une alternative, même partielle, réduit cette
        dépendance critique.
      </p>

      <h2 style={s.h2}>Formaliser une grille d'évaluation</h2>
      <p>
        Plutôt que d'évaluer chaque fournisseur au cas par cas, une grille de critères communs (hébergement,
        usage des données, garanties contractuelles, réversibilité) permet de comparer objectivement vos
        options et de documenter vos choix — utile aussi bien pour votre propre gouvernance interne que pour
        démontrer votre démarche lors d'un contrôle, dans le cadre de
        {' '}<Link to="/blog/ai-act-cybersecurite-entreprise" style={s.link}>l'AI Act</Link>{' '}
        ou de {' '}<Link to="/blog/nis2-pme-ce-qui-change" style={s.link}>NIS2</Link>{' '}
        si votre entreprise est concernée.
      </p>
    </BlogArticleLayout>
  );
}

export default BlogArticleGestionFournisseursIA;
